import { authHeader } from './auth-header'
import axiosInstance from "./client"

export const cashboxPlacementService = {
  getAll,
  createOrUpdate,
  getById,
  deleteById,
  getDetailByCashboxId,
}

function getById(cashboxPlacementId) {
  const requestOptions = {
    url: '/api/v1/user/cashbox/placement/' + cashboxPlacementId,
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}

function getAll() {
  const requestOptions = {
    url: '/api/v1/user/cashbox/placement',
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}


function createOrUpdate(jsonData) {
  let formData = new FormData()

  for (var key in jsonData) {
    if (jsonData[key] != null)
      formData.append(key, jsonData[key])
  }
  let rMethod = jsonData["id"] != null ? "PUT" : "POST"
  const requestOptions = {
    url: '/api/v1/user/cashbox/placement',
    method: rMethod,
    data: formData,
    headers: authHeader()
  }

  return axiosInstance(requestOptions)
}


function deleteById(id) {
  const requestOptions = {
    url: `/api/v1/user/cashbox/placement/` + id,
    method: 'DELETE',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}

function getDetailByCashboxId(cashboxId) {
  const requestOptions = {
    url: '/api/v1/user/cashbox/placement_detail/' + cashboxId,
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}